import { render, staticRenderFns } from "./MCookieIcon.vue?vue&type=template&id=49251c10&scoped=true&lang=pug&"
var script = {}
import style0 from "./MCookieIcon.vue?vue&type=style&index=0&id=49251c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49251c10",
  null
  
)

export default component.exports